<div
  *ngIf="passwordPolicy"
  [ngClass]="{'password-policy-info': !passwordResetError, 'password-policy-failed-info': passwordResetError }"
  [class.rtl]="cService.selectedLanguage.isRtl"
>
  <small>
    <p>
      <strong>{{ cService.readyTranslations.security.passwordRequirements }}</strong>
    </p>

    <p>
      <span *ngFor="let policy of lengthPolicies">{{ policy }}<br/></span>
    </p>

    <ng-container *ngIf="mustContainPolicies.length">
      <p>{{ cService.readyTranslations.security.mustContainA }}</p>

      <ul>
        <li *ngFor="let mustPolicy of mustContainPolicies">
          {{ mustPolicy }}
        </li>

        <li *ngIf="passwordPolicy.passwordRequireSpecialChars">
          {{ this.cService.readyTranslations.security.specialCharacter }}:<br/>
          {{ acceptableSpecialChars }}
        </li>
      </ul>
    </ng-container>

    <ng-container *ngIf="otherPolicies.length">
      <p class="otherPolicy" *ngFor="let policy of otherPolicies">{{ policy }}</p>
    </ng-container>
  </small>
</div>
